import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { ThirdwebProvider } from "thirdweb/react";
import { WagmiProvider } from "wagmi";
import { createWalletConfig } from "../../utils/createWalletConfig.js";
/**
 * Standalone wallet connection provider.
 * Wraps ThirdwebProvider, WagmiProvider, and QueryClientProvider.
 * Use wagmi hooks (useAccount, useConnect, useDisconnect) directly inside.
 */
export function WalletProvider(t0) {
  const $ = _c(10);
  const {
    children,
    chains,
    connectors,
    rpcUrls,
    wagmiConfig: wagmiConfigProp,
    queryClient: queryClientProp,
    reconnectOnMount: t1
  } = t0;
  const reconnectOnMount = t1 === undefined ? false : t1;
  const [defaultQueryClient] = useState(_temp);
  const queryClient = queryClientProp ?? defaultQueryClient;
  let t2;
  let t3;
  if ($[0] !== chains || $[1] !== connectors || $[2] !== rpcUrls || $[3] !== wagmiConfigProp) {
    t3 = wagmiConfigProp ?? createWalletConfig({
      chains,
      connectors,
      rpcUrls
    });
    $[0] = chains;
    $[1] = connectors;
    $[2] = rpcUrls;
    $[3] = wagmiConfigProp;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  t2 = t3;
  const wagmiConfig = t2;
  let t4;
  if ($[5] !== children || $[6] !== queryClient || $[7] !== reconnectOnMount || $[8] !== wagmiConfig) {
    t4 = _jsx(ThirdwebProvider, {
      children: _jsx(WagmiProvider, {
        config: wagmiConfig,
        reconnectOnMount,
        children: _jsx(QueryClientProvider, {
          client: queryClient,
          children
        })
      })
    });
    $[5] = children;
    $[6] = queryClient;
    $[7] = reconnectOnMount;
    $[8] = wagmiConfig;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp() {
  return new QueryClient();
}